import { getDay, isAfter, isBefore } from 'date-fns';
import type { Schedule } from '../types/schedule.type';
import { weekDays } from '../constants';

export function isWithinServiceHours(schedule: Schedule, date: Date): boolean {
  const weekDay = getDay(date);
  const dayName = weekDays[weekDay];
  const day = schedule[dayName];
  return (
    day.startTime != undefined && 
    day.endTime != undefined && 
    isAfter(date, day.startTime) && 
    isBefore(date, day.endTime)
  );
}
